import React, { Component, Fragment } from 'react'
import { connect } from "react-redux"
import SchoolInformation from "./SchoolInformation"
import { SchoolInformationActions } from "../../../../store"
import spinner from "../../../ui/icons/spinner.gif";
import lodashUtil from 'lodash';
import { ValidationUtil } from './index'
import { toast } from 'react-toastify';
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { MuiGrid } from '../../../ui';
import theme from '../../../../assests/theme'
import { withRouter } from 'react-router-dom';
class AddSchoolInformationContainer extends Component {
  constructor(props) {
    super(props)
    this.init(props)
  }
  init = (props) => {
    let activeSchool = {}
    activeSchool.name = "";
    activeSchool.address = {
      line1: "",
      city: "",
      pincode: "",
      country: ""
    };
    activeSchool.website = ""
    activeSchool.primaryPhoneNumber = "";
    activeSchool.secodaryPhoneNumber = "";
    activeSchool.email = undefined;
    if (props.activeSchool != undefined && !lodashUtil.isEmpty(props.activeSchool)) {
      if (!props.isCreateNewSchool) {
        activeSchool = props.activeSchool;
        if (props.isCreateNewSchool !== false) {
          props.setIsCreateNewSchool(false)
        }

      } else {
        if (props.isCreateNewSchool !== false) {
          props.setIsCreateNewSchool(false)
        }
      }
    } else {
      if (props.isCreateNewSchool !== false) {
        props.setIsCreateNewSchool(false)
      }
    }
    if (activeSchool.email === undefined && (props.userInformation.email !== null || props.userInformation.email !== undefined)) {
      activeSchool.email = props.userInformation.email
    }
    props.setActiveSchool(activeSchool)
    this.state = {
      activeSchool: activeSchool,
      errors: [""],
      error: {},
      count: 0,
      isEditNotAllowed: false,
      showDialog: false,
      previousProps: JSON.parse(JSON.stringify(props.activeSchool)),
      isSaved: false
    };
  }
  handleChange = (name, event) => {

    let tempActiveSchool = this.state.activeSchool;
    tempActiveSchool[name] = event.target.value;
    this.setState({
      activeSchool: tempActiveSchool,
      showDialog: true

    })
  }
  handleChangeOfAddress = (name, event) => {
    let tempAddress = this.state.activeSchool.address;
    tempAddress[name] = event.target.value;
    let tempActiveSchool = this.state.activeSchool;
    tempActiveSchool.address = tempAddress
    this.setState({
      activeSchool: tempActiveSchool,
      showDialog: true
    })
  }

  handleChangeOfPhone = (event, data, name) => {
    let tempActiveSchool = this.state.activeSchool;
    tempActiveSchool[name] = event
    tempActiveSchool[name + "Val"] = event.replace(/[^0-9]+/g, '').slice(data.dialCode.length)
    this.setState({
      activeSchool: tempActiveSchool,
      showDialog: true
    })
  }

  onClickOfSave = async (showDialog) => {
    const i18n = this.props.i18n
    let count = this.state.count
    let activeSchool = this.state.activeSchool;
    let validation = ValidationUtil.validateForm(activeSchool, i18n);
    let primaryPhoneNumberValidation = ValidationUtil.phoneNumberValidation(i18n, activeSchool.primaryPhoneNumberVal, true);
    let secondaryPhoneNumberValidation = ValidationUtil.phoneNumberValidation(i18n, activeSchool.secondaryPhoneNumberVal);
    let profiles = this.props.userInformation.profiles;
    let uniqueSchoolNameFlag = this.uniqueSchoolNameValidationWhenAdding(activeSchool, profiles)
    if (count === 0) {
      if (validation.formValid
        && uniqueSchoolNameFlag
        && primaryPhoneNumberValidation.validation
        && secondaryPhoneNumberValidation.validation) {
        count++
        let school = await this.props.saveSchoolInformation(this.props.userInformation._id, this.state.activeSchool)
        toast(i18n.toastMsgs.schoolInformationSavedSuccessfully)

        this.setState({
          error: {},
          isSaved: true
        })
      }
    }
    this.setState({
      count: count,
      showDialog: showDialog,
      errors: validation.errors,
      primaryPhoneNumberError: primaryPhoneNumberValidation.phoneNumberError,
      secondaryPhoneNumberError: secondaryPhoneNumberValidation.phoneNumberError
    });
  }

  uniqueSchoolNameValidationWhenAdding = (activeSchool, profiles) => {
    const i18n = this.props.i18n
    let currentSchoolName = activeSchool.name;
    let schoolList = lodashUtil.find(profiles, ["profileType", "OWNER"]);
    if (schoolList !== undefined) {
      for (let i = 0; i < schoolList.schools.length; i++) {
        let schoolName = schoolList.schools[i].name
        if (currentSchoolName.toLowerCase().trim() === schoolName.toLowerCase().trim()) {
          let errorMessage_UniqueSchoolName = StringReplacer.getFormatedMessage(i18n.schoolInformationTab.UniqueSchoolName,
            {
              schoolName: currentSchoolName,
            })

          this.state.error.name = errorMessage_UniqueSchoolName
          return false;
        }
      }
    }
    return true;
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["schoolInformation"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.isCreateNewSchool !== undefined && nextProps.isCreateNewSchool !== false) {
      this.init(nextProps)
    }
  }
  componentWillUnmount = async () => {
    if (this.state.showDialog && !this.state.isSaved) {
      await this.beforeUnload()
    }
  }

  undoChanges = () => {
    if (this.state.previousProps.name !== undefined) {
      let previousProps = this.state.previousProps
      this.props.activeSchool.name = previousProps.name
      this.props.activeSchool.primaryPhoneNumber = previousProps.primaryPhoneNumber
      this.props.activeSchool.secondaryPhoneNumber = previousProps.secondaryPhoneNumber
      this.props.activeSchool.address.line1 = previousProps.address.line1
      this.props.activeSchool.email = previousProps.email
      this.props.activeSchool.address.city = previousProps.address.city
      this.props.activeSchool.address.pincode = previousProps.address.pincode
      this.props.activeSchool.website = previousProps.website
      this.props.activeSchool.address.country = previousProps.address.country
    }
    this.setState({
      showDialog: false
    })
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.schoolInformationTab.msgForUnsavedChangesInTab);
    if (flag) {
      await this.onClickOfSave()
    }
    else {
      await this.undoChanges()
    }
  }
  render() {
    if (this.props.isSaved === true || this.props.saveSchoolInformationInProcess == true) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' >
        <img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    return (<Fragment>{this.props.saveSchoolInformationInProcess == true ? <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
      : <SchoolInformation
        {...this.props}
        {...this.state}
        onClickOfSave={this.onClickOfSave}
        handleChange={this.handleChange}
        handleChangeOfAddress={this.handleChangeOfAddress}
        handleChangeOfPhone={this.handleChangeOfPhone}
        showContextualHelp={this.showContextualHelp}

      />}</Fragment>

    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  setIsCreateNewSchool: (isCreateNewSchool) => dispatch(SchoolInformationActions.setIsCreateNewSchool(isCreateNewSchool)),
  saveSchoolInformation: (ownerId, data) => dispatch(SchoolInformationActions.saveSchoolInformation(ownerId, data)),

}
)

const mapStateToProps = (state) => {
  return {
    saveSchoolInformationInProcess: state.schoolInformation.saveSchoolInformationInProcess,
    userInformation: state.userProfile.userInformation,
    activeProfileType: state.userProfile.activeProfileType,
    activeSchool: state.schoolInformation.activeSchool,
    isCreateNewSchool: state.schoolInformation.isCreateNewSchool
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddSchoolInformationContainer));
